const client_id = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const script = `
var GoogleAuth;
function init() {
    gapi.load('auth2', function(){
        window.GoogleAuth = gapi.auth2.init({
            client_id: '${client_id}',
            scope: 'openid profile email'
        })
    })
}
`;
const src = 'https://apis.google.com/js/platform.js?onload=init';

export default {
    script,
    src,
};


